import * as types from './actionTypes';

// Regular action creators
// ------- Fetch Parties
export function fetchParties() {
  return {
    type: types.FETCH_PARTIES_REQUEST
  };
}

export function fetchPartiesSuccess({ data, offset }) {
  return {
    type: types.FETCH_PARTIES_SUCCESS,
    data,
    offset
  };
}

export function fetchPartiesFail({ error }) {
  return {
    type: types.FETCH_PARTIES_FAIL,
    error
  };
}
// ------- Fetch Party
export function fetchParty({ id }) {
  return {
    type: types.FETCH_PARTY_REQUEST,
    id
  };
}

export function fetchPartySuccess({ data, id }) {
  return {
    type: types.FETCH_PARTY_SUCCESS,
    data,
    id
  };
}

export function fetchPartyFail({ error, id }) {
  return {
    type: types.FETCH_PARTY_FAIL,
    error,
    id
  };
}

// ------- updatePartyPerson
export function updatePartyPerson({ id, payload }) {
  return {
    type: types.UPDATE_PARTY_PERSON_REQUEST,
    id,
    payload
  };
}

export function updatePartyPersonSuccess({ data, id }) {
  return {
    type: types.UPDATE_PARTY_PERSON_SUCCESS,
    data,
    id
  };
}

export function updatePartyPersonFail({ error, id }) {
  return {
    type: types.UPDATE_PARTY_PERSON_FAIL,
    error,
    id
  };
}
// ------- updatePartyCompany
export function updatePartyCompany({ id, payload }) {
  return {
    type: types.UPDATE_PARTY_COMPANY_REQUEST,
    id,
    payload
  };
}

export function updatePartyCompanySuccess({ data, id }) {
  return {
    type: types.UPDATE_PARTY_COMPANY_SUCCESS,
    data,
    id
  };
}

export function updatePartyCompanyFail({ error, id }) {
  return {
    type: types.UPDATE_PARTY_COMPANY_FAIL,
    error,
    id
  };
}
// ------- updatePartyAddresses
export function updatePartyAddresses({ id, payload }) {
  return {
    type: types.UPDATE_PARTY_ADDRESSES_REQUEST,
    id,
    payload
  };
}

export function updatePartyAddressesSuccess({ data, id }) {
  return {
    type: types.UPDATE_PARTY_ADDRESSES_SUCCESS,
    data,
    id
  };
}

export function updatePartyAddressesFail({ error, id }) {
  return {
    type: types.UPDATE_PARTY_ADDRESSES_FAIL,
    error,
    id
  };
}
// ------- updatePartyContacts
export function updatePartyContacts({ id, payload }) {
  return {
    type: types.UPDATE_PARTY_CONTACTS_REQUEST,
    id,
    payload
  };
}

export function updatePartyContactsSuccess({ data, id }) {
  return {
    type: types.UPDATE_PARTY_CONTACTS_SUCCESS,
    data,
    id
  };
}

export function updatePartyContactsFail({ error, id }) {
  return {
    type: types.UPDATE_PARTY_CONTACTS_FAIL,
    error,
    id
  };
}
// ------- updatePartyBankAccounts
export function updatePartyBankAccounts({ id, payload }) {
  return {
    type: types.UPDATE_PARTY_BANK_ACCOUNTS_REQUEST,
    id,
    payload
  };
}

export function updatePartyBankAccountsSuccess({ data, id }) {
  return {
    type: types.UPDATE_PARTY_BANK_ACCOUNTS_SUCCESS,
    data,
    id
  };
}

export function updatePartyBankAccountsFail({ error, id }) {
  return {
    type: types.UPDATE_PARTY_BANK_ACCOUNTS_FAIL,
    error,
    id
  };
}
// ------- updatePartyRelations
export function updatePartyRelations({ id, payload }) {
  return {
    type: types.UPDATE_PARTY_RELATIONS_REQUEST,
    id,
    payload
  };
}

export function updatePartyRelationsSuccess({ data, id }) {
  return {
    type: types.UPDATE_PARTY_RELATIONS_SUCCESS,
    data,
    id
  };
}

export function updatePartyRelationsFail({ error, id }) {
  return {
    type: types.UPDATE_PARTY_RELATIONS_FAIL,
    error,
    id
  };
}
// ------- printChangePaymentCard
export function changePaymentCard({ payload }) {
  return {
    type: types.CHANGE_PAYMENT_CARD_REQUEST,
    payload
  };
}

export function changePaymentCardSuccess({ data }) {
  return {
    type: types.CHANGE_PAYMENT_CARD_SUCCESS,
    data,
  };
}

export function changePaymentCardFail({ error }) {
  return {
    type: types.CHANGE_PAYMENT_CARD_FAIL,
    error,
  };
}
// ------- load more Parties
export function loadMoreParties({ offset }) {
  return {
    type: types.LOAD_MORE_PARTIES_REQUEST,
    offset
  };
}

export function loadMorePartiesSuccess({ data, offset }) {
  return {
    type: types.LOAD_MORE_PARTIES_SUCCESS,
    data,
    offset
  };
}

export function loadMorePartiesFail({ error }) {
  return {
    type: types.LOAD_MORE_PARTIES_FAIL,
    error
  };
}

// ------- Fetch Genders
export function fetchGenders() {
  return {
    type: types.FETCH_GENDERS_REQUEST
  };
}

export function fetchGendersSuccess({ data, id }) {
  return {
    type: types.FETCH_GENDERS_SUCCESS,
    data,
    id
  };
}

export function fetchGendersFail({ error, id }) {
  return {
    type: types.FETCH_GENDERS_FAIL,
    error,
    id
  };
}